export default "__VITE_PUBLIC_ASSET__1b62f115__"